import analytics from "../../analytics";
import { CSSEvent, RegisterObject } from "../../types/model";

function getCustom(event: CSSEvent) {
  return {
    page_type: "events",
    local_store: event.location.store.storeNo,
  };
}

export function sendSuccessEvent(
  registerObject: RegisterObject,
  event: CSSEvent
) {
  const totallCount =
    (registerObject.childCount || 0) + registerObject.adultCount;
  analytics.sendEvent(
    {
      label: `${totallCount}`,
      action: "event_signup_complete",
    },
    getCustom(event)
  );
}

export function sendRemindersEvent(items: string[], event: CSSEvent) {
  const data_reminder = {
    label: items.toString(),
    action: "event_reminder",
  };

  analytics.sendEvent(data_reminder, getCustom(event));
}

export const sendError = analytics.sendError;
